import { call, put, takeLatest, all } from 'redux-saga/effects';

import errorHandler from '../utils/requestErrorHandler';
import { BannerApi } from '../api';
import { FETCH_BANNER_REQUEST } from '../constants/actionTypes';
import { fetchBannerFail, fetchBannerSuccess } from '../actionCreators/banner';

function * fetchBanner () {
  try {
    const result = yield call(BannerApi.fetchBanner);
    yield put(fetchBannerSuccess(result.data || []));
  } catch (error) {
    yield put(fetchBannerFail(error));
    //yield errorHandler(error);
  }
}

export default function * fetchBannerRoot () {
  yield all([takeLatest(FETCH_BANNER_REQUEST, fetchBanner)]);
}
